import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import "./../Styles/Designes.css";
import { API, UPLOADS } from "./../../config/api";
import { useLocation } from "react-router-dom";
const categories = ["Malti", "Sequience", "Cording", "Chain", "Beads"];
const areaOptions = [125, 250, 300, 400]; // Your specific area sizes
const colorOptions = [
  { label: "1 ", value: "1" },
  { label: "2 ", value: "2" },
  { label: "3 ", value: "3" },
  { label: "4 ", value: "4" },
  { label: "5 ", value: "5" },
  { label: "6 ", value: "6" },
  { label: "7 ", value: "7" },
  { label: "8 ", value: "8" },
  { label: "9 ", value: "9" },
  { label: "10", value: "10" },
  { label: "11", value: "11" },
  { label: "12", value: "12" },
];

export default function Designes() {
  const navigate = useNavigate();
  const location = useLocation();
  /* ================= STATE ================= */
  const [designs, setDesigns] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]); // Array for multi-select
  const [search, setSearch] = useState("");
  const [wishlistIds, setWishlistIds] = useState([]);
  const [cartIds, setCartIds] = useState([]);
  const [minInput, setMinInput] = useState(0);
  const [maxInput, setMaxInput] = useState(400000);
  // Filter States
  const [selectedAreas, setSelectedAreas] = useState([]); // Array for specific area checkboxes
  const [stitchRange, setStitchRange] = useState([0, 500000]);
  const [colorFilters, setColorFilters] = useState([]);
  const [concepts, setConcepts] = useState([]);
  const [selectedConcepts, setSelectedConcepts] = useState([]);
  /* ================= PAGINATION STATE ================= */
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(40);
  const [showAdModal, setShowAdModal] = useState(false);
  const [adTimer, setAdTimer] = useState(30);
  const [pendingDownloadUrl, setPendingDownloadUrl] = useState(null);
  const [downloaded, setDownloaded] = useState({});
  const fetchConcepts = async () => {
    try {
      const res = await fetch(API.CONCEPT_LIST);
      const data = await res.json();

      if (data.status) {
        setConcepts(data.data);
      }
    } catch (error) {
      console.log("Concept fetch error", error);
    }
  };
  const resetFilters = () => {
    setSelectedCategories([]);
    setSearch("");
    setSelectedAreas([]);
    setStitchRange([0, 400000]);
    setColorFilters([]);
    setSelectedConcepts([]);
    setCurrentPage(1);
  };
  useEffect(() => {
    setCurrentPage(1);
    setSearch("");
  }, [location.pathname]);

  const handleCategoryClick = (cat) => {
    setSelectedAreas([]);
    setStitchRange([0, 400000]);
    setColorFilters([]);
    setSelectedConcepts([]);
    setSearch("");
    setCurrentPage(1);

    if (cat === "ALL") {
      setSelectedCategories([]);
    } else {
      setSelectedCategories([cat]);
    }
  };
  useEffect(() => {
    setMinInput(stitchRange[0]);
    setMaxInput(stitchRange[1]);
  }, [stitchRange]);
  /* ================= FETCH & SYNC ================= */
  useEffect(() => {
    fetchDesigns();
    fetchConcepts(); // ✅ ADD THIS
    syncLocalState();
  }, []);

  useEffect(() => {
    setCurrentPage(1);
  }, [
    selectedCategories,
    search,
    selectedAreas,
    stitchRange,
    colorFilters,
    itemsPerPage,
  ]);

  const fetchDesigns = async () => {
    try {
      const res = await fetch(API.LIST_ALL_DESIGNS);
      const data = await res.json();
      if (data.status) setDesigns(data.data);
    } catch (error) {
      console.error("Fetch Error:", error);
    }
  };

  const syncLocalState = () => {
    const loginUser = JSON.parse(sessionStorage.getItem("user"));
    if (loginUser) {
      const cart =
        JSON.parse(localStorage.getItem(`cart_${loginUser.id}`)) || [];
      const wishlist =
        JSON.parse(localStorage.getItem(`wishlist_${loginUser.id}`)) || [];
      setCartIds(cart.filter((i) => i.type === "design").map((i) => i.id));
      setWishlistIds(
        wishlist.filter((i) => i.type === "design").map((i) => i.id),
      );
    }
  };
  const triggerDownload = (file, category, code, id) => {
    const url = `${API.DOWNLOAD}?file=${category.toLowerCase()}/emb/${file}`;

    setPendingDownloadUrl({
      url,
      code,
      id,
    });

    setAdTimer(30);
    setShowAdModal(true);
  };
  /* ================= FILTER LOGIC ================= */
  const filteredDesigns = designs.filter((d) => {
    const categoryMatch =
      selectedCategories.length === 0 ||
      selectedCategories.includes(d.category);

    const searchMatch =
      d.design_code?.toLowerCase().includes(search.toLowerCase()) ||
      d.id?.toString().includes(search);

    const areaMatch =
      selectedAreas.length === 0 || selectedAreas.includes(parseInt(d.area));

    const dStitch = parseInt(d.stitch) || 0;
    const stitchMatch = dStitch >= stitchRange[0] && dStitch <= stitchRange[1];

    let colorMatch = true;
    if (colorFilters.length > 0) {
      const cCount = parseInt(d.color) || 0;
      colorMatch = colorFilters.some((filterVal) => {
        if (filterVal === "4") return cCount >= 4;
        return cCount.toString() === filterVal;
      });
    }

    // ✅ NEW: Concept Filter
    // ✅ FIXED: Concept Filter (OR logic - any one concept match)
    const conceptMatch =
      selectedConcepts.length === 0 ||
      selectedConcepts.some((id) => d.concepts_array?.includes(id)); // ✅ This is OR logic

    return (
      categoryMatch &&
      searchMatch &&
      stitchMatch &&
      colorMatch &&
      areaMatch &&
      conceptMatch
    );
  });

  /* ================= HANDLERS ================= */
  const toggleCategory = (cat) => {
    setSelectedCategories((prev) =>
      prev.includes(cat) ? prev.filter((c) => c !== cat) : [...prev, cat],
    );
  };

  const toggleArea = (area) => {
    setSelectedAreas((prev) =>
      prev.includes(area) ? prev.filter((a) => a !== area) : [...prev, area],
    );
  };

  /* ================= PAGINATION ================= */
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentDesigns = filteredDesigns.slice(
    indexOfFirstItem,
    indexOfLastItem,
  );
  const totalPages = Math.ceil(filteredDesigns.length / itemsPerPage);
  const paginate = (n) => {
    setCurrentPage(n);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  useEffect(() => {
    if (!showAdModal) return;

    if (adTimer <= 0) return;

    const interval = setInterval(() => {
      setAdTimer((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [showAdModal, adTimer]);
  /* ================= ACTIONS (CART/WISHLIST) ================= */
  const handleCardClick = (design) =>
    navigate(`/designe-details/${design.id}`, { state: design });

  const addToCart = (design) => {
    const user = JSON.parse(sessionStorage.getItem("user"));
    if (!user) return alert("Please Login First");
    let items = JSON.parse(localStorage.getItem(`cart_${user.id}`)) || [];
    const exists = items.find((i) => i.id === design.id && i.type === "design");
    if (exists) {
      items = items.filter((i) => !(i.id === design.id && i.type === "design"));
      setCartIds((prev) => prev.filter((id) => id !== design.id));
    } else {
      items.push({ ...design, type: "design" });
      setCartIds((prev) => [...prev, design.id]);
    }
    localStorage.setItem(`cart_${user.id}`, JSON.stringify(items));
    window.dispatchEvent(new Event("cartUpdated"));
  };

  const addToWishlist = (design) => {
    const user = JSON.parse(sessionStorage.getItem("user"));
    if (!user) return;
    let items = JSON.parse(localStorage.getItem(`wishlist_${user.id}`)) || [];
    const exists = items.find((i) => i.id === design.id && i.type === "design");
    if (exists) {
      items = items.filter((i) => !(i.id === design.id && i.type === "design"));
      setWishlistIds((prev) => prev.filter((id) => id !== design.id));
    } else {
      items.push({ ...design, type: "design" });
      setWishlistIds((prev) => [...prev, design.id]);
    }
    localStorage.setItem(`wishlist_${user.id}`, JSON.stringify(items));
    window.dispatchEvent(new Event("cartUpdated"));
  };
  const handleDownload = (file, category, designCode) => {
    if (!file || !category) {
      alert("File missing");
      return;
    }

    const url = `${API.DOWNLOAD}?file=${category.toLowerCase()}/emb/${file}`;

    const link = document.createElement("a");
    link.href = url;

    let ext = "emb";

    if (file.includes(".zip")) ext = "zip";
    else if (file.includes(".rar")) ext = "rar";

    link.download = `${designCode}.${ext}`;

    document.body.appendChild(link);
    link.click();
    link.remove();
  };
  useEffect(() => {
    let interval;
    if (showAdModal && adTimer > 0) {
      interval = setInterval(() => {
        setAdTimer((prev) => prev - 1);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [showAdModal, adTimer]);
  const toggleConcept = (id) => {
    setSelectedConcepts((prev) =>
      prev.includes(id) ? prev.filter((c) => c !== id) : [...prev, id],
    );
  };

  const filteredConcepts =
    selectedCategories.length === 0
      ? concepts
      : concepts.filter((c) => selectedCategories.includes(c.category));

  const normalizeCategory = (cat) => cat?.trim().toLowerCase();

  const groupedConcepts = filteredConcepts.reduce((acc, concept) => {
    const key = normalizeCategory(concept.category);

    if (!acc[key]) acc[key] = [];
    acc[key].push(concept);

    return acc;
  }, {});
  return (
    <div className="designs-page container-fluid py-4">
      <div className="row g-4">
        {/* SIDEBAR FILTER */}
        <div className="col-lg-2 col-md-12">
          <div className="uniq-filter-sidebar shadow-sm p-3 bg-white rounded sticky-top">
            <h5 className="uniq-filter-title">Filters</h5>
            <hr />

            {/* Search */}
            <div className="uniq-filter-section mb-4">
              <label className="uniq-filter-label">Search Code</label>
              <div className="uniq-search-wrapper">
                <i className="bi bi-search uniq-search-icon"></i>
                <input
                  type="text"
                  className="form-control form-control-sm uniq-input"
                  placeholder="Code..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>
            </div>

            {/* Area Filter (NOW CHECKBOXES) */}
            <div className="uniq-filter-section mb-4">
              <label className="uniq-filter-label">Area (mm)</label>
              <div className="uniq-color-group">
                {areaOptions.map((area) => (
                  <div className="form-check uniq-check" key={area}>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id={`area-${area}`}
                      checked={selectedAreas.includes(area)}
                      onChange={() => toggleArea(area)}
                    />
                    <label
                      className="form-check-label"
                      htmlFor={`area-${area}`}
                    >
                      {area}mm
                    </label>
                  </div>
                ))}
              </div>
            </div>

            {/* Stitch Range (DUAL SLIDER) */}
            <div className="uniq-filter-section mb-4">
              <label className="uniq-filter-label">Stitch Range</label>

              {/* MIN MAX INPUT BOXES */}
              <div className="d-flex gap-2 mb-3">
                <input
                  type="number"
                  className="form-control form-control-sm"
                  placeholder="Min"
                  value={minInput}
                  onFocus={(e) => {
                    // ✅ FIXED: Clear ONLY if it shows the default stitchRange value
                    if (e.target.value === stitchRange[0].toString()) {
                      setMinInput("");
                    }
                  }}
                  onChange={(e) => {
                    const inputValue = e.target.value;
                    setMinInput(inputValue); // Always update display value first

                    // Convert to number only if not empty
                    const value = inputValue === "" ? 0 : Number(inputValue);

                    if (!isNaN(value) && value >= 0) {
                      setStitchRange([value, Math.max(value, stitchRange[1])]);
                    }
                  }}
                  onBlur={(e) => {
                    const inputValue = e.target.value;
                    const value = inputValue === "" ? 0 : Number(inputValue);

                    // Only reset if completely empty
                    if (inputValue === "") {
                      setMinInput("0");
                      setStitchRange([0, stitchRange[1]]);
                    } else if (isNaN(value) || value < 0) {
                      // Reset to original min if invalid
                      setMinInput(stitchRange[0].toString());
                    }
                  }}
                />

                <input
                  type="number"
                  className="form-control form-control-sm"
                  placeholder="Max"
                  value={maxInput}
                  onFocus={(e) => {
                    // ✅ FIXED: Clear ONLY if it shows the default stitchRange value
                    if (e.target.value === stitchRange[1].toString()) {
                      setMaxInput("");
                    }
                  }}
                  onChange={(e) => {
                    const inputValue = e.target.value;
                    setMaxInput(inputValue); // Always update display value first

                    // Convert to number only if not empty
                    const value =
                      inputValue === "" ? stitchRange[1] : Number(inputValue);

                    if (!isNaN(value) && value >= 0) {
                      setStitchRange([
                        stitchRange[0],
                        Math.max(stitchRange[0], value),
                      ]);
                    }
                  }}
                  onBlur={(e) => {
                    const inputValue = e.target.value;
                    const value =
                      inputValue === "" ? stitchRange[1] : Number(inputValue);

                    // Only reset if completely empty
                    if (inputValue === "") {
                      setMaxInput(stitchRange[1].toString());
                    } else if (isNaN(value) || value < 0) {
                      // Reset to original max if invalid
                      setMaxInput(stitchRange[1].toString());
                    }
                  }}
                />
              </div>

              {/* DISPLAY CURRENT RANGE */}
              {/* <div className="text-center mt-2">
                <span className="uniq-badge">
                  {stitchRange[0].toLocaleString()} -{" "}
                  {stitchRange[1].toLocaleString()}
                </span>
              </div> */}
            </div>
            <div className="uniq-filter-section">
              <label className="uniq-filter-label">Colors</label>
              <div className="uniq-color-group">
                {colorOptions.map((opt) => (
                  <div className="form-check uniq-check" key={opt.value}>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id={`color-${opt.value}`}
                      checked={colorFilters.includes(opt.value)}
                      onChange={(e) => {
                        if (e.target.checked)
                          setColorFilters([...colorFilters, opt.value]);
                        else
                          setColorFilters(
                            colorFilters.filter((item) => item !== opt.value),
                          );
                      }}
                    />
                    <label
                      className="form-check-label"
                      htmlFor={`color-${opt.value}`}
                    >
                      {opt.label}
                    </label>
                  </div>
                ))}
              </div>
            </div>

            <div className="uniq-filter-section mb-4">
              <label className="uniq-filter-label">Concepts</label>

              {categories
                .filter((cat) => groupedConcepts[normalizeCategory(cat)])
                .map((category) => {
                  const key = normalizeCategory(category);

                  return (
                    <div key={category} className="mb-3">
                      <h6 className="fw-bold1">{category}</h6>

                      <div className="uniq-color-group">
                        {groupedConcepts[key].map((c) => (
                          <div className="form-check uniq-check" key={c.id}>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              checked={selectedConcepts.includes(c.id)}
                              onChange={() => toggleConcept(c.id)}
                            />
                            <label className="form-check-label">
                              {c.concept_name}
                            </label>
                          </div>
                        ))}
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        </div>

        {/* MAIN CONTENT */}
        <div className="col-lg-8 col-md-12">
          {/* HEADING AND HORIZONTAL CATEGORIES */}
          <div className="horizontal-categories-wrapper mb-3">
            <div className="d-flex align-items-center flex-wrap gap-3">
              <h2 className="section-title mb-0 me-3">Designs</h2>

              <div className="design-categories">
                <button
                  className={`btn btn-md ${selectedCategories.length === 0 ? "btn-primary" : "btn-outline-teal"}`}
                  onClick={() => handleCategoryClick("ALL")}
                >
                  All
                </button>
                {categories.map((cat) => (
                  <button
                    key={cat}
                    className={`btn btn-md  ${selectedCategories.includes(cat) ? "btn-primary" : "btn-outline-teal"}`}
                    onClick={() => handleCategoryClick(cat)}
                  >
                    {cat}
                  </button>
                ))}
              </div>

              <div className="ms-auto d-flex align-items-center gap-2">
                <span className="small text-muted">Show:</span>
                <select
                  className="form-select form-select-sm"
                  style={{ width: "80px" }}
                  value={itemsPerPage}
                  onChange={(e) => setItemsPerPage(parseInt(e.target.value))}
                >
                  <option value={20}>20</option>
                  <option value={40}>40</option>
                  <option value={100}>100</option>
                </select>
              </div>
            </div>

            <div className="designs-grid">
              {currentDesigns.length > 0 ? (
                currentDesigns.map((design) => (
                  <div
                    className="design-card"
                    key={design.id}
                    onClick={() => handleCardClick(design)}
                  >
                    <div className="image-wrapper">
                      <img
                        src={`${UPLOADS.DESIGN_IMAGE}${design.category.toLowerCase()}/jpg/${design.jpeg_file}`}
                        alt={design.design_code}
                      />
                    </div>
                    <div className="card-body">
                      <div className="design-specs">
                        <div className="spec-left">
                          <div>
                            <strong className="strong1">Code:</strong>{" "}
                            {design.design_code}
                          </div>
                          <div>
                            <strong className="strong1">Stitch:</strong>{" "}
                            {design.stitch}
                          </div>
                        </div>
                        <div className="spec-right text-start">
                          <div>
                            <strong className="strong1">Area:</strong>{" "}
                            {design.area}
                          </div>
                          <div>
                            <strong className="strong1">Color:</strong>{" "}
                            {design.color}
                          </div>

                          {/* <div><strong>Detail:</strong> {design.details}</div> */}
                        </div>
                      </div>
                      <div className="design-specs">
                        <div>
                          <strong className="strong1">Concept:</strong>{" "}
                          {design.concepts_array
                            ?.map((id) => {
                              const concept = concepts.find((c) => c.id == id);
                              return concept ? concept.concept_name : null;
                            })
                            .filter(Boolean)
                            .join(", ")}
                        </div>
                      </div>

                      <h5 className="price-tag-row text-center mt-2">₹ 0</h5>
                      <div className="card-action-row">
                        {/* <div className="action-btns">
                          <button
                            className={`select-btn ${cartIds.includes(design.id) ? "selected-btn" : ""}`}
                            onClick={(e) => {
                              e.stopPropagation();
                              addToCart(design);
                            }}
                          >
                            <i
                              className={`bi ${cartIds.includes(design.id) ? "bi-cart-check-fill" : "bi-cart-fill"} me-1`}
                            ></i>
                            {cartIds.includes(design.id)
                              ? "SELECTED"
                              : "SELECT"}
                          </button>
                          <button
                            className="wish-btn"
                            onClick={(e) => {
                              e.stopPropagation();
                              addToWishlist(design);
                            }}
                          >
                            <i
                              className={`bi ${wishlistIds.includes(design.id) ? "bi-heart-fill text-danger" : "bi-heart"}`}
                            ></i>
                          </button>
                        </div> */}
                        <div className="action-btns">
                          {downloaded[design.id] ? (
                            <button className="btn btn-teal1 btn-sm">
                              <i className="bi bi-check-circle-fill me-1"></i>
                              Downloaded
                            </button>
                          ) : (
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                triggerDownload(
                                  design.emb_file,
                                  design.category,
                                  design.design_code,
                                  design.id,
                                );
                              }}
                              className="btn btn-teal btn-sm"
                            >
                              <i className="bi bi-download me-1"></i>
                              Download
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="text-center py-5 w-100">
                  <h4>No designs match your filters.</h4>
                </div>
              )}
            </div>

            {/* PAGINATION */}
            {totalPages > 1 && (
              <div className="pagination-container d-flex justify-content-center mt-5">
                <ul className="pagination custom-pagination">
                  {/* ... pagination logic remains same ... */}
                  {[...Array(totalPages)].map((_, index) => (
                    <li
                      key={index + 1}
                      className={`page-item ${currentPage === index + 1 ? "active" : ""}`}
                    >
                      <button
                        className="page-link"
                        onClick={() => paginate(index + 1)}
                      >
                        {index + 1}
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>
        <div className="col-lg-2 d-none d-lg-block">
          <div className="ads-sidebar p-3 bg-white shadow-sm rounded text-center sticky-top">
            <h5 className="ads-title">Sponsored</h5>
            <div className="ad-card mt-3">
              <div className="ad-placeholder">
                <p className="small text-muted">Your Ad Here</p>
              </div>
              <p className="small mt-2">Premium Threads Sale!</p>
            </div>
          </div>
        </div>
      </div>
      {showAdModal && (
        <div className="custom-modal-overlay">
          <div className="custom-modal-dialog">
            <div className="custom-modal-content">
              <div className="modal-header-custom">
                <h2 className="modal-title">Unlocking Your Design</h2>
                <p>We provide 100% free designs thanks to our sponsors.</p>
              </div>

              <div className="ad-card">
                <div className="ad-badge">SPONSORED AD</div>
                <div className="ad-body">
                  {/* <h4 className="ad-brand">Premium Embroidery Supplies</h4>
            <p className="ad-offer">Upgrade your toolkit with 20% off all thread kits.</p> */}
                  <h4 className="ad-brand">Your Ads Here</h4>

                  <div className="ad-visual-placeholder">
                    {/* You can place an actual <img> here */}
                    <div className="pulse-loader"></div>
                  </div>
                </div>
              </div>

              <div className="action-section">
                {adTimer > 0 ? (
                  <div className="timer-wrapper">
                    <span className="timer-text">Preparing your file...</span>
                    <div className="timer-number">{adTimer}s</div>
                  </div>
                ) : (
                  <div className="download-ready-area">
                    <p className="ready-msg"> Your file is ready!</p>
                    <button
                      className="btn-download-glow"
                      onClick={() => {
                        if (!pendingDownloadUrl?.url) return;

                        const link = document.createElement("a");
                        link.href = pendingDownloadUrl.url;

                        let ext = "emb";
                        if (pendingDownloadUrl.url.includes(".zip"))
                          ext = "zip";
                        else if (pendingDownloadUrl.url.includes(".rar"))
                          ext = "rar";

                        link.download = `${pendingDownloadUrl.code}.${ext}`;

                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);

                        setDownloaded((prev) => ({
                          ...prev,
                          [pendingDownloadUrl.id]: true,
                        }));

                        setShowAdModal(false);
                      }}
                    >
                      Download Now
                    </button>
                  </div>
                )}
              </div>

              <button
                className="btn-close-modal"
                onClick={() => setShowAdModal(false)}
              >
                Maybe later
              </button>
            </div>
          </div>
        </div>
      )}
      <style>{`
        .btn-teal { background-color: #00a99d; color: white; border: none; padding: 10px; width:100%;}
        
.btn-teal1 { background-color: #146862; color: white; border: none; padding: 10px; width:100%;}
        .design-img-box { overflow: hidden; position: relative; background: #f8f9fa; }
        
        /* BILLARY MIRROR (Zoom Lens) CSS */
    

        .object-fit-contain { object-fit: contain; }



/* Modal Box */
.custom-modal-content {
  background: #ffffff;
  width: 90%;
  max-width: 450px;
  border-radius: 24px;
  padding: 40px;
  text-align: center;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.2);
  position: relative;
  margin-left:16px;
}

.modal-title {
  font-weight: 800;
  color: #1e293b;
  margin-bottom: 8px;
  font-size: 1.5rem;
}

/* Ad Container Styling */
.ad-card {
  background: #f8fafc;
  border: 2px dashed #cbd5e1;
  border-radius: 16px;
  padding: 20px;
  margin: 25px 0;
  position: relative;
}

.ad-badge {
  position: absolute;
  top: -12px;
  left: 50%;
  transform: translateX(-50%);
  background: #10334b;
  color: white;
  font-size: 10px;
  font-weight: bold;
  padding: 4px 12px;
  border-radius: 20px;
  letter-spacing: 1px;
}

.ad-brand {
  color: #132e4d;
  font-weight: 700;
  margin-top: 10px;
}

/* Timer Styling */
.timer-number {
  font-size: 2.5rem;
  font-weight: 800;
  color: #ef4444;
  margin-top: 10px;
}

/* Pulsing Loader Animation */
.pulse-loader {
  width: 40px;
  height: 40px;
  border: 4px solid #e2e8f0;
  border-top: 4px solid #2e4563;
  border-radius: 50%;
  margin: 15px auto;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Glow Download Button */
.btn-download-glow {
  display: inline-block;
  background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%);
  color: white;
  text-decoration: none;
  padding: 15px 30px;
  border-radius: 12px;
  font-weight: bold;
  font-size: 1.1rem;
  width: 100%;
  box-shadow: 0 10px 15px -3px rgba(34, 197, 94, 0.4);
  transition: transform 0.2s ease;
}

.btn-download-glow:hover {
  transform: translateY(-2px);
  color: white;
}

.btn-close-modal {
  background: none;
  border: none;
  color: #94a3b8;
  margin-top: 20px;
  cursor: pointer;
  font-size: 0.9rem;
  text-decoration: underline;
}
      `}</style>
    </div>
  );
}
